import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import PageHero from '@/components/feature/PageHero';

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      <PageHero label="Privacy Policy" title="プライバシーポリシー" />

      {/* Content */}
      <section className="py-16">
        <div className="max-w-3xl mx-auto px-6">
          <div className="prose prose-slate max-w-none space-y-10 text-sm text-slate-600 leading-relaxed">

            <div>
              <p>
                合同会社リンク（以下「当社」）は、お客様の個人情報の保護を重要な責務と考え、以下のプライバシーポリシーを定め、適切な管理・保護に努めます。
              </p>
            </div>

            {[
              {
                title: '1. 個人情報の収集について',
                content: '当社は、サービスの提供、お問い合わせへの対応、講座・セミナーの運営等の目的のために、お名前、メールアドレス、電話番号、会社名等の個人情報を収集することがあります。個人情報の収集は、適法かつ公正な手段によって行います。',
              },
              {
                title: '2. 個人情報の利用目的',
                content: '収集した個人情報は、以下の目的のために利用します。\n・サービスの提供および改善\n・お問い合わせへの対応\n・講座・セミナーの運営および連絡\n・マーケティング情報のご案内（ご同意いただいた場合）\n・法令に基づく対応',
              },
              {
                title: '3. 個人情報の第三者提供',
                content: '当社は、以下の場合を除き、お客様の個人情報を第三者に提供することはありません。\n・お客様の同意がある場合\n・法令に基づく場合\n・人の生命、身体または財産の保護のために必要な場合',
              },
              {
                title: '4. 個人情報の管理',
                content: '当社は、個人情報の漏洩、滅失、毀損等を防止するため、適切なセキュリティ対策を実施します。個人情報へのアクセスは、業務上必要な担当者に限定します。',
              },
              {
                title: '5. Cookieの使用について',
                content: '当社のウェブサイトでは、サービス向上のためにCookieを使用することがあります。ブラウザの設定によりCookieを無効にすることができますが、一部のサービスが利用できなくなる場合があります。',
              },
              {
                title: '6. 個人情報の開示・訂正・削除',
                content: 'お客様は、当社が保有するご自身の個人情報について、開示・訂正・削除を請求することができます。ご請求の際は、お問い合わせフォームよりご連絡ください。',
              },
              {
                title: '7. プライバシーポリシーの変更',
                content: '当社は、法令の変更や事業内容の変更等に伴い、本プライバシーポリシーを変更することがあります。変更後のポリシーは、当ウェブサイトに掲載した時点から効力を生じるものとします。',
              },
              {
                title: '8. お問い合わせ',
                content: '個人情報の取り扱いに関するお問い合わせは、以下の窓口までご連絡ください。\n\n合同会社リンク\n〒171-0052 東京都豊島区南長崎三丁目7番6号 グランエッグス落合07号\nメール：contact@link-corp.link',
              },
            ].map((section) => (
              <div key={section.title}>
                <h4 className="text-base font-semibold text-slate-800 mb-3">
                  <a id={section.title} className="scroll-mt-24">{section.title}</a>
                </h4>
                <p className="whitespace-pre-line">{section.content}</p>
              </div>
            ))}

            <div className="pt-6 border-t border-sky-100">
              <p className="text-slate-400 text-xs">制定日：令和6年11月13日</p>
              <p className="text-slate-400 text-xs mt-1">合同会社リンク</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
